import styled from '@emotion/styled';
import React from 'react';
import { ArrowBackIcon, StyledIconLink } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

interface IBackLinkProps {
	url: string;
}

export const AvailabilityNoResultsBackLink = ({ url }: IBackLinkProps) => {
	const { t } = useTranslation();

	return (
		<StyledBackLink href={url}>
			<ArrowBackIcon aria-hidden variation="highlight" />
			<> </>
			{t('web_parking_availability_results_try_again_button')}
		</StyledBackLink>
	);
};

const StyledBackLink = styled(StyledIconLink)`
	margin-top: 24px;
`;
